import { styled } from "theme/default/styled";

export const SUsersChangeRowRolesInputIcon = styled.button`
  margin-left: 32px;
`;
